import { CSSProperties } from 'react';
import styles from './styles.module.css';

import cn from 'classnames';

export function Joystick(props: IJoystickProps) {
  const {
    className,
    size = 'default',
    onTop,
    onLeft,
    onRight,
    onBottom,
    ...rest
  } = props;
  const rootClass = cn(className, styles.root, styles[`root_${size}`]);

  // TODO: заменить символы на иконки, после внедрения механизма иконок-рефакторинга
  return (
    <div className={rootClass} {...rest}>
      <div className={cn(styles.item, styles.top)} onClick={onTop}>
        <SvgArrow/>
      </div>
      <div className={cn(styles.item, styles.left)} onClick={onLeft}>
        <SvgArrow style={{ transform: 'rotate(-90deg)' }}/>
      </div>
      <div className={cn(styles.item, styles.bottom)} onClick={onBottom}>
      <SvgArrow style={{ transform: 'rotate(180deg)' }}/>
      </div>
      <div className={cn(styles.item, styles.right)} onClick={onRight}>
      <SvgArrow style={{ transform: 'rotate(90deg)' }}/>
      </div>
    </div>
  );
}

export interface IJoystickProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'small' | 'default' | 'large';
  onTop: () => void;
  onBottom: () => void;
  onLeft: () => void;
  onRight: () => void;
}

export function SvgArrow ({ className, style }: { className?: string, style?: CSSProperties }) { 
  return <svg
          className={className}
          style={style}
          width="11"
          height="7"
          viewBox="0 0 11 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.34766 5.60803L5.68029 1.27539L10.0129 5.60803"
            stroke="#0F172A"
            strokeWidth="0.866527"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
}